let Quote = require('./Quote.js');

module.exports = {
    cache: function(questions) {
        window.localStorage.setItem('questions_cache', JSON.stringify(questions));
    },
    get: function(key) {
        let t = window.localStorage.getItem(key);
        if (t === undefined) {
            return null;
        }
        return JSON.parse(t);
    },
    set: function(key, value) {
        window.localStorage.setItem(key, JSON.stringify(value));
    },

    hasQuestions: function() {
        return (this.get('questions_cache') !== null);
    },
    hasAnswers: function(...keys) {
        let error = false;
        keys.map(function(key) {
            if (!this.getCurrentAnswer(key)) {
                error = true;
            }
        }, this);

        return !error;
    },
    clearAnswers: function() {
        window.localStorage.removeItem("answers");
    },
    clearAnswer(key) {
        let q = this.get("answers");
        if (q === null && q === undefined) {
            return false;
        }

        q.map(function(k) {
            if (k.question == key) {
                //
            }
        }, this);
    },
    getCurrentAnswer: function(key) {
        let t = window.localStorage.getItem(key);
        if (t === undefined) {
            return null;
        }
        return JSON.parse(t);
    },
    markStep1: function() {
        this.set('step1', true);
    },
    hasStep1: function() {
        return (this.get('step1') === true);

    },
    getSteps: function() {
        let d = this.get('questions_cache');
        let steps = [];
        $.each(d, function(k, v) {
            if (k === 'steps') {
                $.each(v, function(k2, v2) {
                   steps.push(v2);
                });
            }
        });

        return steps;
    },

    getCurrentStepTitle: function() {

    },

    getQuestionById: function(questionId) {
        let found = false;
        let steps = this.getSteps();

        steps.map(function(step) {
            $.each(step.questions, function() {
                if (this.question_id === questionId) {
                    found = this;
                }
            });
        }, this);

        return (found === false) ? false : found;
    },

    hasOtherAnswerOptions: function(fieldName) {
        let q = this.getQuestionByFieldName(fieldName);
        return (q.other_options === undefined) ? false : true;
    },
    getOtherAnswerOptions: function(fieldName) {
        let q = this.getQuestionByFieldName(fieldName);
        if (q.other_options == undefined) {
            return [];
        }
        return q.other_options;
    },

    getQuestionByFieldName: function(fieldName) {
        let found = false;
        let steps = this.getSteps();

        steps.map(function(step) {
            $.each(step.questions, function() {
                if (this.field_name === fieldName) {
                    found = this;
                }
            });
        }, this);

        return (found === false) ? false : found;
    },
    getQuestionTitleByFieldName: function(fieldName) {
        let found = false;
        let steps = this.getSteps();

        steps.map(function(step) {
            $.each(step.questions, function() {
                if (this.field_name === fieldName) {
                    found = this;
                }
            });
        }, this);

        return (found === false) ? false : found;
    },

    getChildQuestions: function(parentId, activeValue) {
        let childQuestions = new Array();
        let steps = this.getSteps();
        let _this = this;

        // we map the sort data to all the child dependencies first (not the most efficient
        // method, but its still incredibly quick)
        // add sort data into the display dependencies
        steps.map(step => {
            $.each(step.questions, function(qIndex, question) {
                $.each(question.display_dependencies, function(dIndex, displayDependency) {
                    let fullChildQuestionId = _this.getQuestionById(displayDependency.child_question_id);
                    displayDependency.sort = fullChildQuestionId.sort;
                });
            });
        });

        // sort the child dependencies
        steps.map(step => {
            $.each(step.questions, function(qIndex, question) {
                $.each(question.display_dependencies, function() {
                    question.display_dependencies.sort(function(a, b) {
                        return (a.sort - b.sort);
                    });
                });
            });
        });

        // then map everything
        steps.map(step => {
            $.each(step.questions, function(qIndex, question) {
                $.each(question.display_dependencies, function(dIndex, displayDependency) {
                    if (displayDependency.parent_question_id === parentId && displayDependency.display_child_on_parent_value === activeValue) {
                        let find = _this.getQuestionById(displayDependency.child_question_id);
                        if (find) {
                            childQuestions.push(find);
                        }
                    }
                });
            });
        }, this);
        return (childQuestions.length > 0) ? childQuestions : null;
    },

    /**
     * get all the child questions for a question where the child question
     * ISNT active - i.e the child question should be shown on a parent value
     * of "yes" and the parent value is currently "no"
     * @param  {int} parentId the id of the parent question to get child questions for
     * @param  {string} activeValue the current value of the parent question
     * @return {array[Object]} all the current non active child questions for the parent question ID
     */
    getNonActiveChildQuestions : function(parentId, activeValue) {
        let childQuestions = new Array();
        let steps = this.getSteps();
        let _this = this;

        // we map the sort data to all the child dependencies first (not the most efficient
        // method, but its still incredibly quick)
        // add sort data into the display dependencies
        steps.map(step => {
            $.each(step.questions, function(qIndex, question) {
                $.each(question.display_dependencies, function(dIndex, displayDependency) {
                    let fullChildQuestionId = _this.getQuestionById(displayDependency.child_question_id);
                    displayDependency.sort = fullChildQuestionId.sort;
                });
            });
        });

        // sort the child dependencies
        steps.map(step => {
            $.each(step.questions, function(qIndex, question) {
                $.each(question.display_dependencies, function() {
                    question.display_dependencies.sort(function(a, b) {
                        return (a.sort - b.sort);
                    });
                });
            });
        });

        // then map everything
        steps.map(step => {
            $.each(step.questions, function(qIndex, question) {
                $.each(question.display_dependencies, function(dIndex, displayDependency) {
                    if (displayDependency.parent_question_id === parentId && displayDependency.display_child_on_parent_value != activeValue) {
                        let find = _this.getQuestionById(displayDependency.child_question_id);
                        if (find) {
                            childQuestions.push(find);
                        }
                    }
                });
            });
        }, this);
        return (childQuestions.length > 0) ? childQuestions : null;
    },

    getAnswerDependencies: function(parentId) {
        let steps = this.getSteps();
        let fieldNames = [];
        steps.map(step => {
            $.each(step.questions, function(qIndex, question) {
                $.each(question.answer_dependencies, function(dIndex, combinedAnswer) {
                    if (combinedAnswer.parent_question_id === parentId) {
                        fieldNames.push(combinedAnswer.field_name);
                    }
                });
            });
        });

        return fieldNames;
    },

    getChildren(childrenParam) {
        if (childrenParam !== undefined && childrenParam.length > 0) {

            // Build the array of potential answers
            let answersArray = new Array();

            $.each(childrenParam, function(key, child) {
                let found = false;

                answersArray.map(function(s) {
                    if (s.key === child.display_child_on_parent_value) {
                        found = true;
                    }
                }, this);

                if (!found) {
                    let n = {
                        "key": child.display_child_on_parent_value,
                        "children" : new Array
                    };
                    answersArray.push(n);
                }

            });

            // Assign child question id's to each unqiue answer
            $.each(answersArray, function(ik, answer){
                 $.each(childrenParam, function(childKey, child) {
                    if (answer.key === child.display_child_on_parent_value) {
                        answersArray[ik].children.push(child.child_question_id);
                    }
                 });
            });

            return answersArray;

        } else {

            return null;
        }
    },

    childrenAreActive(childrenParam, fieldName) {
        if (childrenParam !== undefined && childrenParam.length > 0) {

            // Build the array of potential answers
            let found = false;
            $.each(childrenParam, function(key, child) {
                if (child.display_child_on_parent_value === Quote.getCurrentAnswer(fieldName)) {
                    found = true;
                }
            });
            return found;
        } else {
            return false;
        }
    },
    guid() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)+Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)+Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)+Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)+Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)+Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)+Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)+Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1)+Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
    }
};



/** WEBPACK FOOTER **
 ** ./src/components/Managers/Questions.js
 **/